<template>
    <div class="grid grid-cols-5">
        <div
          v-for="(label, star) in stars"
          class="text-center md:mx-5 cursor-pointer text-gray-500"
          :class="{'text-indigo-600': hoveredStar ? star <= hoveredStar : star <= modelValue}"
          @mouseenter="hoveredStar = star"
          @mouseleave="hoveredStar = null"
          @click="$emit('update:modelValue', star)"
        >
            <div class="flex justify-center mb-3">
                <Star class="w-5 md:w-7"/>
            </div>

            <p class="text-xs md:text-sm" v-text="label"/>
        </div>
    </div>
</template>

<script>
import Star from '@/Components/Svg/Star.vue';

export default {
    components: { Star },
    props: ['modelValue'],
    data() {
        return {
            hoveredStar: null,

            stars: {
                1: 'Погано',
                2: 'Ну таке',
                3: 'Норм',
                4: 'Добре',
                5: 'Топчик',
            },
        }
    }
};
</script>
